// AddItemsModal.js
import {
    Button, Checkbox, Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Table, Tbody,
    Td,
    Tr
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { fetchSupplies } from '../../api';
import { useTableColors } from '../../Utils';

const AddItemsModal = ({ isOpen, onClose, onAddItems, requestedItems }) => {
    const [supplies, setSupplies] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const coolors = useTableColors();

    useEffect(() => {
        if (isOpen) {
            console.log(requestedItems)
            loadSupplies();
            setSelectedItems([]); // Reset selected items when modal opens
        }
    }, [isOpen]);

    const loadSupplies = async () => {
        const result = await fetchSupplies(false);
        if (result.success) {
            // Filter out supplies that are already in the order
            const existingItemIds = new Set(requestedItems.map(item => item.item._id.toString()));

            const filteredSupplies = result.data.filter(supply =>
                !existingItemIds.has(supply._id.toString())  // Only include supplies not in existing items
            );

            setSupplies(filteredSupplies);
        }
    };

    const handleSelectItem = (supply, quantity) => {
        setSelectedItems(prevItems => {
            const itemIndex = prevItems.findIndex(i => i.itemId === supply._id);

            if (itemIndex !== -1) {
                // Update quantity for already selected item
                prevItems[itemIndex].quantity = quantity;
            } else {
                // Add new item to selection
                prevItems.push({ itemId: supply._id, name: supply.name, quantity });
            }

            // Remove item if quantity is zero (unselected)
            return prevItems.filter(item => item.quantity > 0);
        });
    };

    const handleAddItems = () => {
        onAddItems(selectedItems);
        onClose();
    };

    return (
        <Modal scrollBehavior='inside' size={'4xl'} isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Select Supplies</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Table variant="simple" size="md">
                        <Tbody>
                            {supplies.map((supply, index) => (
                                <Tr
                                    key={supply._id}
                                    borderBottom={`2px solid ${coolors.borderColor}`}
                                    bg={index % 2 === 0 ? coolors.rowBgEven : coolors.rowBgOdd}
                                    color={coolors.textColor}
                                    _hover={{ bg: coolors.rowHoverBg, color: "white" }}
                                >
                                    <Td>
                                        <Checkbox
                                            onChange={(e) =>
                                                handleSelectItem(supply, e.target.checked ? 1 : 0)
                                            }
                                        >
                                            {supply.name}
                                        </Checkbox>
                                    </Td>

                                    <Td>{supply.size}</Td>

                                    <Td>
                                        <Input
                                            type="number"
                                            min="1"
                                            defaultValue="1"
                                            onChange={(e) =>
                                                handleSelectItem(supply, parseInt(e.target.value, 10))
                                            }
                                            disabled={
                                                !selectedItems.some((item) => item.itemId === supply._id)
                                            }
                                            bg={coolors.selectBg}
                                            color={coolors.selectText}
                                            borderColor={coolors.selectBorder}
                                            _placeholder={{ color: coolors.selectPlaceholder }}
                                        />
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>

                </ModalBody>
                <ModalFooter>
                    <Button onClick={onClose} mr={3}>Cancel</Button>
                    <Button colorScheme="blue" onClick={handleAddItems}>Add</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default AddItemsModal;
